(function () {
  window.AFI = window.AFI || {};

  var AFI_ENDPOINT =
    'https://afi-analytics-engine.adam-filipek.workers.dev/api/event';

  function sendEvent(eventType, payload) {
    if (!eventType) {
      return Promise.reject(
        new Error('Brak typu zdarzenia')
      );
    }

    var body = Object.assign(
      {},
      payload || {},
      {
        event_type: eventType,
        path: window.location.pathname,
        referrer: document.referrer || null
      }
    );

    return fetch(AFI_ENDPOINT, {
      method: 'POST',

      /*
       * Tracker nie musi odczytywać odpowiedzi Workera.
       * no-cors zapobiega blokowaniu żądania przez przeglądarkę.
       */
      mode: 'no-cors',

      headers: {
        'Content-Type': 'text/plain;charset=UTF-8'
      },

      body: JSON.stringify(body),
      keepalive: true
    });
  }

  window.AFI.track = sendEvent;

  function getProductFromShopifyAnalytics() {
    var product =
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product;

    if (
      !product ||
      !product.id ||
      !product.handle
    ) {
      return null;
    }

    return {
      id: product.id,
      handle: product.handle
    };
  }

  function getProductHandleFromPath() {
    var match =
      window.location.pathname.match(
        /^\/products\/([^/?#]+)/
      );

    return match
      ? decodeURIComponent(match[1])
      : null;
  }

  function getProductFromProductJson() {
    var handle =
      getProductHandleFromPath();

    if (!handle) {
      return Promise.resolve(null);
    }

    return fetch(
      '/products/' +
        encodeURIComponent(handle) +
        '.js',
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Nie udało się pobrać danych produktu'
          );
        }

        return response.json();
      })
      .then(function (product) {
        if (
          !product ||
          !product.id
        ) {
          return null;
        }

        return {
          id: product.id,
          handle:
            product.handle || handle
        };
      })
      .catch(function (error) {
        console.warn(
          'AFI: nie udało się pobrać produktu:',
          error
        );

        return null;
      });
  }

  function saveProductView(product) {
    if (
      !product ||
      !product.id ||
      !product.handle
    ) {
      console.warn(
        'AFI: niepełne dane produktu',
        product
      );

      return;
    }

    var storageKey =
      'afi_product_view_' +
      product.id;

    if (
      sessionStorage.getItem(storageKey)
    ) {
      console.log(
        'AFI: odsłona była już zapisana w tej sesji',
        product.handle
      );

      return;
    }

    sendEvent('product_view', {
      product_id: product.id,
      handle: product.handle
    })
      .then(function () {
        /*
         * W trybie no-cors odpowiedź jest typu opaque,
         * ale samo wykonanie Promise oznacza, że przeglądarka
         * zaakceptowała wysłanie żądania.
         */
        sessionStorage.setItem(
          storageKey,
          '1'
        );

        console.log(
          'AFI: wysłano odsłonę produktu',
          product.handle
        );
      })
      .catch(function (error) {
        console.error(
          'AFI: nie udało się wysłać odsłony:',
          error
        );
      });
  }

  function trackProductView() {
    console.log('AFI: start');

    var product =
      getProductFromShopifyAnalytics();

    console.log(
      'AFI: ShopifyAnalytics',
      product
    );

    if (product) {
      saveProductView(product);
      return;
    }

    console.log(
      'AFI: próbuję pobrać /products/*.js'
    );

    getProductFromProductJson()
      .then(function (fallbackProduct) {
        console.log(
          'AFI: product.js',
          fallbackProduct
        );

        if (!fallbackProduct) {
          console.warn(
            'AFI: nie rozpoznano strony produktu'
          );

          return;
        }

        saveProductView(
          fallbackProduct
        );
      });
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      trackProductView,
      {
        once: true
      }
    );
  } else {
    trackProductView();
  }
})();